import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext(null);
export const useCart = () => useContext(CartContext);

const KEY = "fixigo_cart";

export function CartProvider({ children }) {
  const [items, setItems] = useState(() => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; } catch { return []; }
  });

  useEffect(() => { localStorage.setItem(KEY, JSON.stringify(items)); }, [items]);

  const keyOf = (s) => `${s.product_category}|${s.product_type}|${s.service_type}|${s.part_name || ""}`;

  const add = (s) => {
    setItems((prev) => prev.some((x) => keyOf(x) === keyOf(s)) ? prev : [...prev, s]);
  };
  const remove = (s) => setItems((prev) => prev.filter((x) => keyOf(x) !== keyOf(s)));
  const has = (s) => items.some((x) => keyOf(x) === keyOf(s));
  const clear = () => setItems([]);
  const total = items.reduce((a, s) => a + (s.amount || 0), 0);

  return (
    <CartContext.Provider value={{ items, add, remove, has, clear, total, keyOf }}>
      {children}
    </CartContext.Provider>
  );
}
